import React from "react";
import styles from "./content.module.scss";
import { AiFillCheckCircle } from "react-icons/ai";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

const Content = ({
  benefitTitle,
  src,
  layout,
  background,
  benefitLists,
  featureTitle,
  featureSubtitle,
  featureLists,
}) => {
  let cx = classNames.bind(styles);
  const layoutType = cx([layout]);

  const data = useStaticQuery(graphql`
    query {
      feature_01: file(relativePath: { eq: "feature_01.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      feature_02: file(relativePath: { eq: "feature_02.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      feature_03: file(relativePath: { eq: "feature_03.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      benefit_02: file(relativePath: { eq: "benefit_02.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      benefit_03: file(relativePath: { eq: "benefit_03.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      benefit_04: file(relativePath: { eq: "benefit_04.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  const benefitItem = benefitLists.map((benefit, index) => (
    <li key={index}>
      <AiFillCheckCircle />
      {benefit}
    </li>
  ));

  const featureItem = featureLists.map((feature, index) => (
    <li className={styles.featureList} key={index}>
      <span className={styles.summary}>{feature.summary}</span>
      <span className={styles.detail}>{feature.detail}</span>
    </li>
  ));

  return (
    <div
      className={classNames(
        styles.wrapper,
        background ? styles.background : ""
      )}
    >
      <div className={classNames(styles.container, layoutType)}>
        <div className={styles.info}>
          <div className={styles.benefitWrap}>
            <h3 className={styles.benefitTitle}>{benefitTitle}</h3>
            <ul className={styles.benefitLists}>{benefitItem}</ul>
          </div>

          <div className={styles.featureWrap}>
            <h3 className={styles.featureTitle}>{featureTitle}</h3>
            <p className={styles.featureSubtitle}>{featureSubtitle}</p>
            <ul className={styles.featureLists}>{featureItem}</ul>
          </div>
        </div>
        <Img
          className={styles.graphic}
          fluid={data[src].childImageSharp.fluid}
        />
      </div>
    </div>
  );
};

Content.defaultProps = {
  benefitTitle: "",
  src: "",
  benefitLists: [],
  layout: "layoutA",
  background: false,
  featureTitle: "",
  featureSubtitle: "",
  featureLists: [],
};

Content.propTypes = {
  benefitTitle: PropTypes.string,
  src: PropTypes.string,
  benefitLists: PropTypes.array,
  layout: PropTypes.string,
  background: PropTypes.bool,
  featureTitle: PropTypes.string,
  featureSubtitle: PropTypes.string,
  featureLists: PropTypes.array,
};

export default Content;
